module.exports = __webpack_public_path__ + "img/superyacht-logo.354dec35.png";